import * as React from "react";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Clear } from "@mui/icons-material";
import { ELIMINAR_RED } from "../graphql/mutations";
import { MainContext } from "../../../../../Context/MainCtx";
import { useMutation } from "@apollo/client";
import { CircularProgress } from "@mui/material";

export default function EliminarRedSocial({ data, refetch }) {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const { snackMessage } = React.useContext(MainContext);
  const [eliminarRedSocial] = useMutation(ELIMINAR_RED);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDeleteRedSocial = async () => {
    try {
      handleClose();
      setLoading(true);
      const res = await eliminarRedSocial({
        variables: {
          idRedSocial: data._id,
        },
      });
      snackMessage({
        message: res.data.eliminarRedSocial.message,
        variant: "success",
      });
      refetch();
      setLoading(false);
    } catch (err) {
      setLoading(false);
      snackMessage({
        message: err.message ? err.message : "Error Desconocido",
        variant: "error",
      });
    }
  };

  return (
    <div>
      <IconButton onClick={() => handleClickOpen()}>
        {loading ? <CircularProgress size={20} color="inherit" /> : <Clear />}
      </IconButton>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{`Eliminar ${data.redSocial}`}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Se va a eliminar este elemento, ¿Quiere continuar?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus color="inherit">
            No, cancelar
          </Button>
          <Button
            onClick={() => handleDeleteRedSocial()}
            color="error"
            variant="contained"
            disableElevation
          >
            Si, eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
